import { CmmStatus } from "../../../../enums/cmmStatus";

export const allCmmOptions = [
  { label: "Success", value: CmmStatus.COMPLETED },
  { label: "Started", value: CmmStatus.INITIATED },
  { label: "In Progress", value: CmmStatus.IN_PROGRESS },
  { label: "Error", value: CmmStatus.FAILED },
  { label: "Invalid Key", value: CmmStatus.INVALID_KEY },
  { label: "Duplicate Key", value: CmmStatus.DUPLICATE_KEY },
  { label: "Patient Mismatch", value: CmmStatus.PATIENT_MISMATCH },
  { label: "Additional QA", value: CmmStatus.ADDITIONAL_QA },
  { label: "STP Failed", value: CmmStatus.STP_FAILED },
  { label: "Expired", value: CmmStatus.EXPIRED },
  { label: "Not Started", value: CmmStatus.NOT_STARTED },
];
